// Browser geolocation for "cheapest near you", with the last-known position
// persisted in local storage so returning users aren't re-prompted every visit.
// This is the ONLY location path — if the user declines or geolocation is
// unavailable, results fall back to national prices (no city picker).

const STORAGE_KEY = 'geoLocation'
// A saved position expires so we don't silently claim "prices near you" from a
// weeks-old location (e.g. scanned in Zagreb, now in Split).
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export function getSavedLocation() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const loc = JSON.parse(raw)
    if (typeof loc?.lat !== 'number' || typeof loc?.lon !== 'number') return null
    if (loc.ts && Date.now() - loc.ts > MAX_AGE_MS) return null // stale → re-prompt
    return { lat: loc.lat, lon: loc.lon }
  } catch {
    return null
  }
}

export function saveLocation(loc) {
  try {
    if (loc) localStorage.setItem(STORAGE_KEY, JSON.stringify({ lat: loc.lat, lon: loc.lon, ts: Date.now() }))
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
  return loc ? { lat: loc.lat, lon: loc.lon } : null
}

// Ask the browser for the current position. Resolves { lat, lon } or rejects
// (permission denied / unsupported / timeout).
export function requestLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('geolocation-unsupported'))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      (err) => reject(err),
      { timeout: 8000, maximumAge: 5 * 60 * 1000 }
    )
  })
}
